// A tab left open: signed image links last 24-48 hours (server/auth.js), so a
// page that has been open about a day may be showing (or about to show) broken
// logos and photos. When the visitor comes back to the tab, reload it once
// instead, so they always see a fresh page.
export const STALE_AFTER_MS = 20 * 60 * 60 * 1000;   // well before the earliest expiry (24 h)

export const isStale = (loadedAt, now = Date.now()) => now - loadedAt >= STALE_AFTER_MS;

export function installStaleTabReload(win = window, loadedAt = Date.now()) {
    let reloading = false;
    const check = () => {
        if (reloading || win.document.visibilityState !== "visible" || !isStale(loadedAt)) return;
        reloading = true;
        win.location.reload();
    };
    win.document.addEventListener("visibilitychange", check);
    // Back/forward cache: the page comes back as it was, with its old links.
    win.addEventListener("pageshow", (e) => { if (e.persisted) check(); });
    return check;
}
